import ActionType from '../ActionType'
import { list, create, read/* , deleteEntity  */} from 'actions/data'
import { createEmbedding, relevantInfoFunc } from 'components/VastGPT/redux'
import { DATA_API_URL } from 'utils/AllURLs'
import messageContent from './messageContent'

export const setLoadingInbox = payload => ({
  type: ActionType.VastGPT.SET_LOADING_INBOX,
  payload,
})

export const clearRelevantInfoInbox = () => ({
  type: ActionType.VastGPT.CLEAR_RELEVANT_INFO_INBOX,
})

export const generateInboxResponse =
  ({ conversationItem, index }) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const send = messages =>
        dispatch(
          create({
            entity: {
              messages,
              status: 'REQUEST',
            },
            entityType: 'openaiinboxresponse',
            hasSchema: false,
            url: `${DATA_API_URL}/openaiinboxresponse`,
            snackbarMessage: 'none',
          }),
        ).then(createPayload => {
          let currentInterval = 250 // Start with 250 milliseconds
          const increaseFactor = 1.1
          const maxInterval = 3000 // 3 seconds

          const checkStatusAndUpdateInterval = () => {
            dispatch(
              read(
                createPayload.id,
                'openaiinboxresponse',
                null,
                null,
                'object',
                null,
                null,
                `${DATA_API_URL}/openaiinboxresponse/${createPayload.id}`,
              ),
            ).then(readPayload => {
              if (readPayload.status === 'FAILURE') {
                dispatch(setLoadingInbox(false))
                reject(readPayload) // reject the promise with the payload if needed
              } else if (readPayload.status === 'SUCCESS') {
                dispatch(setLoadingInbox(false))
                resolve(readPayload) // resolve the promise with the payload if needed
                // deleteEntity(
                //   createPayload.id,
                //   'openaiinboxresponse',
                //   `${DATA_API_URL}/openaiinboxresponse/${createPayload.id}`,
                // )

                // Maybe do this^ later if we're not storing AI inbox responses,
                // since deleting on SUCCESS would clean up the database. The times when
                // this doesn't happen are probably when a user just closes the window and doesn't 
                // trigger the onClose or onClick event in <InboxAiResponse />.

                // Maybe not on FAILURE since we might want to inspect failure reasons,
                // although I"m not sure if we have any conditions that would trigger that.

              } else if (
                readPayload.status === 'REQUEST' &&
                readPayload.message
              ) {
                dispatch(setLoadingInbox('loadingWithText'))
              }

              // If status isn't 'SUCCESS' or 'FAILURE', schedule the next check
              if (
                !(
                  readPayload.status === 'SUCCESS' ||
                  readPayload.status === 'FAILURE'
                )
              ) {
                currentInterval = Math.min(
                  currentInterval * increaseFactor,
                  maxInterval,
                )
                setTimeout(checkStatusAndUpdateInterval, currentInterval)
              }
            })
          }

          // Kick off the first check immediately
          checkStatusAndUpdateInterval()
        })
      dispatch(clearRelevantInfoInbox())
      dispatch(setLoadingInbox('initial'))

      const content = messageContent(conversationItem, getState)

      return dispatch(
        // TODO: [VR-3183] figure out whether we should make this recursive
        list('knowledge', null, `${DATA_API_URL}/knowledge`),
      ).then(() => {
        return dispatch(createEmbedding(content)).then(embedding =>
          dispatch(relevantInfoFunc({ embedding, type: 'inbox' })).then(
            relevantInfo => {
              const { relevantInformation } = relevantInfo

              const inbox = getState().inbox
              const conversationObj = inbox.conversation
              const originalMessagesArray =
                typeof index === 'number'
                  ? conversationObj?.conversation?.slice(0, index + 1)
                  : conversationObj?.conversation

              const messagesArray = originalMessagesArray
                ?.filter?.(
                  // need to change this once we add emails
                  conversationItem =>
                    Boolean(conversationItem?.sms || conversationItem?.formsub),
                )
                .slice(-10)

              const account = getState().data?.account
              const jwtTokenPayload = getState().auth?.session?.idToken?.payload
              const email = inbox?.fromEmailSelected?.address
              const phone_number = inbox?.fromNumberSelected?.phone_number

              const messages = [
                {
                  // there might be a problem if we ask to respond with sms but they only have email.
                  // maybe we can just set the characters but just add it to an email instead

                  role: 'system',
                  content: `You are a helpful representative that works for ${
                    account?.business_name || 'a business'
                  }. Your location is ${
                    account?.mailing?.address_line_1 || ''
                  } ${account?.mailing?.address_line_2 || ''} ${
                    account?.mailing?.city || ''
                  }, ${account?.mailing?.state_province || ''} ${
                    account?.mailing?.zip || ''
                  } ${account?.mailing?.country || ''}.
                
                ${
                  jwtTokenPayload
                    ? `Your name is ${jwtTokenPayload?.given_name} ${jwtTokenPayload?.family_name} and you are talking to a customer/lead. `
                    : ''
                }
                ${email ? `Your email address is ${email}. ` : ''}
                ${phone_number ? `Your phone number is ${phone_number}. ` : ''}
                
                  You are responding to an incoming text message or a form response.

                  The content for a text message will be given in plaintext.
                  The content for the form response will be given in key value pairs.

                  ${
                    relevantInformation
                      ? `Here is an array of some potentially relevant knowledge, and the most relevant knowledge is at the end of the array:
                      ${relevantInformation}`
                      : ''
                  }
                  
                  Generate a response to the most recent interaction from your customer/lead in 320 characters or less. 
                  In your response do not acknowledge that you are an AI Language model.
                  Do not reference programming nor use terms like "array," "object," or "markdown," unless the term is being used in a non-programming context. 
                  `,
                },
                // ...questionsAndAnswers,
                ...messagesArray.map(conversationItem => ({
                  role:
                    conversationItem?.direction === 'outbound'
                      ? 'assistant'
                      : 'user',
                  content: messageContent(conversationItem, getState),
                })),
              ]

              dispatch(setLoadingInbox('loading'))

              return send(messages)
            },
          ),
        )
      })
    })
